import { useEffect, useState } from "react";
import axios from "axios";
import { GoPencil } from "react-icons/go";
import { TextField, Button } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Bounce, toast } from "react-toastify";

const ProfileOverview = () => {
  const [res, setRes] = useState({});
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [policy, setPolicy] = useState("");
  const token = localStorage.getItem("hiedberg_admin_token");

  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/policy/get`
      );
      setRes(result.data.data);
      setPolicy(result.data.data.policy || "");

      console.log("Policy data fetched successfully:", result.data);
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Error fetching :", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const initialValues = {
    title: res?.title || "",
    policy: policy || "",
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    policy: Yup.string().test(
      "richTextRequired",
      "Policy is required",
      function (value) {
        if (!value) return false;
        const parser = new DOMParser();
        const doc = parser.parseFromString(value, "text/html");
        const cleanText = doc.body.textContent || "";
        return cleanText.trim().length > 0;
      }
    ),
  });

  const policyhandleSubmit = async (values) => {
    const payload = {
      title: values.title,
      policy: policy,
    };
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/policy/update`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(" Policy updated successfully:", response.data);
      fetchData();
      setEditMode(false);
      toast.success("Privacy policy updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error(" Update Error:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="mt-5 space-y-4 overflow-auto pb-6">
        <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
          {loading ? (
            <div className="flex justify-center py-10">
              <div className="h-6 w-6 animate-spin rounded-full border-t-2 border-blue-500"></div>
            </div>
          ) : (
            <>
              <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={validationSchema}
                onSubmit={policyhandleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  resetForm,
                }) => (
                  <Form>
                    <div className="mb-4 flex items-center justify-between">
                      <h3 className="text-lg font-semibold text-gray-800">
                        Privacy Policy
                      </h3>
                      {editMode ? (
                        <div className="flex items-center gap-3">
                          <button
                            type="submit"
                            className="text-sm font-medium text-blue-600 hover:text-blue-800"
                          >
                            Save Changes
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setEditMode(false);
                              resetForm();
                              setPolicy(res?.policy || "");
                            }}
                            className="text-sm font-medium text-gray-500 hover:text-gray-700"
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <GoPencil
                          className="hover:text-black h-5 w-5 cursor-pointer"
                          onClick={() => setEditMode(true)}
                        />
                      )}
                    </div>
                    <div className="flex flex-col gap-y-4">
                      <TextField
                        name="title"
                        label="Title"
                        variant="outlined"
                        size="small"
                        value={values.title}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!editMode}
                        error={touched.title && Boolean(errors.title)}
                        helperText={touched.title && errors.title}
                        fullWidth
                      />

                      <div
                        className={`rounded-xl border bg-white p-4 shadow-sm ${
                          touched.policy && errors.policy
                            ? "border-red-500"
                            : "border-gray-300"
                        }`}
                      >
                        <h3 className="mb-2 text-lg font-semibold text-gray-800">
                          Policy
                        </h3>
                        <SunEditor
                          value={policy}
                          setContents={policy}
                          setDefaultStyle="font-family: inherit; font-size: 14px; line-height: 1.5;"
                          setOptions={{
                            height: "auto",
                            minHeight: "200px",

                            buttonList: [
                              ["undo", "redo"],
                              ["fontColor", "bold", "underline", "italic"],
                              ["font", "fontSize", "formatBlock"],
                              ["align", "list", "lineHeight"],
                            ],

                            toolbarContainer: "#toolbar",
                            showPathLabel: false,
                            resizingBar: false,
                          }}
                          onChange={(content) => {
                            setPolicy(content);
                          }}
                          disable={!editMode}
                        />
                        {touched.policy && errors.policy && (
                          <p className="mt-1 text-sm text-red-500">
                            {errors.policy}
                          </p>
                        )}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfileOverview;
